const getters = {
    getProfile: state => state.profile,
    getSports: state => state.profile.sports,
    allSports: state => state.profile.all_sports,
    isProfileLoaded: state => !!state.profile.firstname,
    userErrors: state => state.userErrors,
    userStatus: state => state.status,
}

export default getters
